// 所有已过时的报表老版接口
export function getDBApi(key) {
  var apis = [];

  apis['DASH_GET_TEAMUSER_LIST'] = 'user/list/?frame=show&username=$&userid=$&p=$&orderby=$&sort=$';

  apis['DASH_SET_FOLLWER_REBET'] = 'user/upedituser';

  apis['GET_ACCOUNT_CR'] = 'report/selfbankreport?userid=$&starttime=$&endtime=$&ordertype=$&status=$&p=$&pn=20';

  apis['GET_LOTTERY_METHOD'] = 'gameinfo/newgamelist';

  apis['GET_BET_RECORD'] = 'gameinfo/?controller=gameinfo&action=newgamelist&username=$&starttime=$&endtime=$&lotteryid=$&methodid=$&isgetprizestatus=$&ischild=$&p=$&pn=20&device=$'

  apis['GET_BET_DETAIL'] = 'gameinfo/newgamedetail/$';

  apis['CHECK_USERNAME'] = 'user/usercheck?username=$'

  apis['CANCEL_BET'] = 'gameinfo/cancelgame/$';

  apis['ADD_USER'] = 'user/adduser';

  apis['GET_PROMOTION_LINK'] = 'user/marketing'

  apis['SET_PROMOTION_LINK'] = 'user/marketing'

  apis['GET_TEAM_STATISTICS'] = 'gameinfo/lotteryteamreport?star_date=$&end_date=$'

  apis['GET_TEAM_STATISTICS_V2'] = 'gameinfo/teamstatistics?start_date=$&end_date=$'

  apis['GET_TEAM_STATISTICS_V3'] = 'realtime/team/lottery?startTime=$&endTime=$'

  apis['GET_DAILY_WAGES'] = 'compact/user/?orderby=$&sort=$&starttime=$&endtime=$&pstatus=$&p=$&pn=24'

  apis['GET_TEAM_CONTRACT'] = '?controller=compact&action=$&username=$&userid=$&pstatus=$&p=$&pn=15'

  apis['GET_TEAM_CONTRACT'] = '?controller=compact&action=$&username=$&userid=$&pstatus=$&p=$&pn=15'
  
  apis['CREATE_CONTRACT'] = '?controller=compact&action=create&type=$'

  apis['CREATE_CONTRACT_XY'] = '?controller=compact&action=createxy&type=$'

  apis['UPDATE_CONTRACT'] = '?controller=compact&action=update&type=$'
  
  apis['GET_TEAM_WAGE'] = '?controller=compact&action=$&orderby=$&sort=$&username=$&userid=$&starttime=$&endtime=$&pstatus=$&p=$&pn=15'

  apis['GET_CASINO_COMPACT'] = '?controller=compact&action=userlive&orderby=$&sort=$&starttime=$&endtime=$&pstatus=$&p=$&pn=15'

  apis['GET_PORKER_COMPACT'] = '?controller=compact&action=userpoker&orderby=$&sort=$&starttime=$&endtime=$&pstatus=$&p=$&pn=15'

  apis['GET_SPORT_COMPACT'] = '?controller=compact&action=usersport&orderby=$&sort=$&starttime=$&endtime=$&pstatus=$&p=$&pn=15'

  apis['GET_KGAME_COMPACT'] = '?controller=compact&action=userkg&orderby=$&sort=$&starttime=$&endtime=$&pstatus=$&p=$&pn=15'
  
  apis['GET_ESPORTS_COMPACT'] = '?controller=compact&action=useresports&orderby=$&sort=$&starttime=$&endtime=$&pstatus=$&p=$&pn=15'

  apis['GET_CHESS_COMPACT'] = '?controller=compact&action=userxy&orderby=$&sort=$&starttime=$&endtime=$&pstatus=$&p=$&pn=15'

  apis['GET_EPROFITLOSS'] = 'gameinfo/eprofitloss?ordername=$&order=$&userid=$&username=$&starttime=$&endtime=$&cid=$&p=$&pn=15'

  apis['GET_USER_TASK'] = 'default/getusertask'

  apis['GET_DAILY_LOSS'] = 'report/dailyloss?username=$&sdate=$&edate=$&status=$&p=$&pn=15'

  apis['GET_MONTH_LOSS'] = 'report/monthlyloss?username=$&sdate=$&edate=$&status=$&p=$&pn=15'

  apis['GET_LOTTERY_REPORT'] = 'gameinfo/historyteamlottery/?orderby=$&sort=$&userid=$&star_date=$&end_date=$&username=$&ischild=$&p=$&pn=20'

  apis['GET_LOTTERY_CR'] = 'gameinfo/lotteryaccountchanged?isgetdata=1&modes=0&userid=$&starttime=$&endtime=$&lotteryid=$&ordertype=$&p=$&pn=20'

  apis['GET_TRACKS'] = 'report/traceinfo?controller=report&action=traceinfo&starttime=$&endtime=$&lotteryid=$&methodid=$&p=$&pn=20'

  apis['GET_TRACK_DETAIL'] = 'report/taskdetail/$'

  apis['STOP_TRACKS'] = 'gameinfo/canceltask'

  apis['CHANGE_LOGIN_PASSWORD'] = 'user/changeloginpass'

  apis['GET_TRANSFER_RECORD'] = 'report/index.php?controller=report&action=fundreport&isgetdata=1&starttime=$&endtime=$&out_money=$&in_money=$&status=$&p=$&pn=20'

  apis['CHECK_SEC_QA'] = '?controller=user&action=checkquestion'

  apis['SET_SEC_PASS'] = '?controller=user&action=retrievesepas'

  apis['CHECK_SEC_PASS'] = '?controller=security&action=checkpass'

  apis['GET_BANK_INFO'] = 'user/?controller=user&action=userbankinfo&check=$'

  apis['LOCK_BANK_CARD'] = '?controller=security&action=deluserbank&flag=lock&id=$';

  apis['ADD_BANK_CARD'] = 'user/?controller=security&action=adduserbank';

  apis['REBIND_BANK_CARD'] = 'security/rebinding/?flag=reset&id=$';

  apis['BIND_PHONE_NUMBER'] = 'user/userbankinfo'

  apis['CHECK_PHONE_NUMBER'] = 'user/checkifphonenumberexists';

  apis['GET_BET_RECORD_FOR_CASINO'] = 'gameinfo/livetigerprojects?isgetdata=1&userid=$&startDate=$&endDate=$&platform=$&p=$&page_size=20'

  apis['TRANSFER_TO_MEMBER'] = 'user/?controller=user&action=saveup'

  apis['GET_GUIDE_TASK_MONEY'] = 'guidetask/award'

  apis['GET_LOTTERY_CONTRACT'] = 'pink/index?sort=asc&orderby=pay_status&username=$&userid=$&cycle_id=$&pay_status=$&p=$&pn=20';

  apis['CHECK_DIVIDENT'] = 'pink/ajaxhub/countpink';

  apis['PROVIDE_DIVIDENT'] = 'pink/checkout';

  apis['GET_LOTTERY_CONTRACT_DETAIL'] = 'pink/ajaxhub/contract?userid=$';

  apis['CREATE_LOTTERY_CONTRACT'] = 'pink/create'

  apis['UPDATE_LOTTERY_CONTRACT'] = 'pink/update'

  apis['GET_TEAM_STATISTICS_BY_TYPE'] = 'gameinfo/teamchart?type=$'

  apis['GET_TEAM_STATISTICS_BY_TYPE_V2'] = 'realtime/team/chart?type=$&incChild=$'

  apis['TAKE_ACTION'] = '?controller=activity&action=play&aid=$'

  return apis[key];
}

/**
 * 打包请求对象
 * @param  {[type]} key       		[请求地址Key]
 * @param  {[type]} urlParam  		[URL资源参数，对象数组]
 * @param  {[type]} postParam 		[对象/JSON串]
 * @param  {[type]} method    		[请求方式 GET, POST, PUT, DELETE  ]
 * @param  {[type]} loading    		[是否需要loading遮罩  ]
 * @return {[type]}           		[请求对象]
 */
export function packageDBReq(key, urlParam, postParam, method, loading, cache) {
  var req = {};
  req.url = getDBApi(key);
  req.method = method;

  if (!req.url) {
    return;
  }

  var paramMap = req.url.split('$');

  //URL参数组装
  if (paramMap.length > 1) {
    req.url = '';
    _.forEach(paramMap, function(val, index) {
      if (val === '') {
        return;
      }

      req.url += val + (!_.isUndefined(urlParam[index]) ? String(urlParam[index]) || '' : '');
    });
  }

  // 所有URL参数来自传入
  if (getDBApi(key) === '$') {
    req.url = urlParam;
  }

  //POST数据
  req.data = postParam ? postParam : undefined;

  req.loading = loading || false;

  if(req.url.indexOf('?') == -1){
    req.url += '?1=1'
  }

  if (cache) {
    req.cache = { key: $.Hex_MD5(key + req.url).substr(0, 8), expires: cache };
  }

  return req;
}
